import { MouseEvent } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '@/components/Icon';

interface SearchAutoSuggestListProps {
  searchAutoSuggestList: string[];
  inputChange: string;
  onClickItem: (suggestion: string) => void;
}

export const SearchAutoSuggestList = ({
  searchAutoSuggestList = [],
  inputChange,
  onClickItem,
}: SearchAutoSuggestListProps) => {
  const { formatMessage } = useIntl();

  const handleOnClickItem = (e: MouseEvent<HTMLLIElement>) => {
    const suggestion = e.currentTarget.textContent;
    onClickItem(suggestion);
  };

  return (
    <ul role="listbox">
      {searchAutoSuggestList.map((searchAutoSuggestElement) => {
        const regex = new RegExp(inputChange, 'gi');
        const content = searchAutoSuggestElement.replace(
          regex,
          `<span style="color: white">$&</span>`
        );

        return (
          <li
            key={searchAutoSuggestElement}
            className="flex p-2 border-b-solid border-b-brand-neutral-700 border-b mx-5 cursor-pointer"
            aria-label={formatMessage(
              { id: 'search.accessibility.button.program' },
              { program: searchAutoSuggestElement }
            )}
            onClick={handleOnClickItem}
          >
            <Icon name="search" className="text-2xl text-brand-neutral-300" />

            <div
              className="text-brand-neutral-300"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </li>
        );
      })}
    </ul>
  );
};
